export default function useCollectionTypeFieldRow(properties, index) {
    // Replace all '__index__' in attr of each field
    const preparedFields = Object.fromEntries(
        Object.entries(properties).map(([fieldKey, fieldProps]) => [
            fieldKey,
            {
                ...fieldProps,
                attr: Object.fromEntries(
                    Object.entries(fieldProps.attr || {}).map(([attrKey, attrValue]) => [
                        attrKey,
                        typeof attrValue === 'string'
                            ? attrValue.replace(/__index__/g, index)
                            : attrValue
                    ])
                )
            }
        ])
    );

    return {
        preparedFields,
        fieldsName: Object.keys(preparedFields),
    }
}
